import React, { useEffect, useState } from "react";
import api from "../../../../api";

const Members = () => {
  const [memberData, setMemberData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const response = await api.get("/api/sitepages/alumni/members");
        setMemberData(response.data.members_data);
      } catch (error) {
        console.error("Error fetching members:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMembers();
  }, []);

  if (loading || !memberData) return null;

  return (
    <section className="faculty_section office pt_80 pb_80" id="faculty">
      <div className="container">
        <div className="row pb-5">
          <div className="col-12 wow fadeIn" data-wow-duration="2s">
            <div className="alumni_side">
              <h3 className="wow fadeIn" data-wow-duration="2s">
                {memberData.heading}
              </h3>
            </div>
          </div>
        </div>

        <div className="accordion" id="accordionfaculty">
          {memberData.accordion.map((group, gIndex) => (
            <div className="accordion-item mb-3" key={gIndex}>
              <h2 className="accordion-header">
                <button
                  className={`accordion-button ${
                    gIndex !== 0 ? "collapsed" : ""
                  }`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#accordion-${gIndex}`}
                  aria-expanded={gIndex === 0 ? "true" : "false"}
                  aria-controls={`accordion-${gIndex}`}
                >
                  {group.title}
                </button>
              </h2>
              <div
                id={`accordion-${gIndex}`}
                className={`accordion-collapse collapse ${
                  gIndex === 0 ? "show" : ""
                }`}
                data-bs-parent="#accordionfaculty"
              >
                <div className="accordion-body">
                  <div className="row justify-content-center">
                    {group.members.map((member, mIndex) => (
                      <div className="col-md-4 mb-3 col-12" key={mIndex}>
                        <div className="single-faculty-item text-center">
                          <div className="faculty-wrapper-alumni  mb-3">
                          <img
                            className="img-fluid facluty-main-image"
                            src={`${process.env.REACT_APP_API_URL}/public/${member.image}`}
                            alt={member.name}
                            loading="lazy"
                          /></div>
                          <h1 className="faculty-title">{member.name}</h1>
                          <p className="faculty-designation">
                            {member.designation}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Members;